module.exports = __webpack_public_path__ + "img/icommunity_sys-08.90fc5bd1.jpg";